import { render, staticRenderFns } from "./settingsComp.vue?vue&type=template&id=00a9fa69&scoped=true&"
import script from "./settingsComp.vue?vue&type=script&lang=js&"
export * from "./settingsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9fa69",
  null
  
)

export default component.exports